import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsInstagramComponent } from './simple-icons-instagram.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsInstagramComponent ],
    exports:      [ SimpleIconsInstagramComponent ],
    bootstrap:    []
})
export class SimpleIconsInstagramModule {}
